import { z } from 'zod';
import { msg } from '@/lib/forms/messages';
import { scoreRange1to10 } from '@/lib/forms/primitives';

// Module-level const, not a `createSchema(t)` factory: msg() resolves at parse time.
// No length caps: every column is TEXT with no CHECK.

// Optional 1..10: api/routes/drbfm.py:266-267 Field(None, ge=1, le=10);
// 040_drbfm_content_review.sql:108-111 CHECK (IS NULL OR BETWEEN 1 AND 10) — the IS NULL is why neither score is required.
const optionalScore = scoreRange1to10.optional();

export const countermeasureReviewSchema = z.object({
  // Mirror: description TEXT NOT NULL (017_drbfm_tables.sql:80).
  description: z.string().trim().min(1, msg('validation.required')),

  // Columns are nullable TEXT, but the server requires all four: application/drbfm/workflow_service.py:709-717
  // rejects blanks on accepted/modified review, and content_readiness_service.py:113-126 blocks readiness on them.
  targetCause: z.string().trim().min(1, msg('validation.required')),
  mechanism: z.string().trim().min(1, msg('validation.required')),
  verificationMethod: z.string().trim().min(1, msg('validation.required')),
  acceptanceCriteria: z.string().trim().min(1, msg('validation.required')),

  validatedEffectivenessScore: optionalScore,
  feasibilityScore: optionalScore,
});
